import { NgModule } from '@angular/core';
import { MutualModule } from '@shared/mutual/mutual.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { FilingRestrictionBlockComponent, SupportSettingsBlockComponent } from './components';

@NgModule({
  imports: [MutualModule, PipesSharedModule],
  exports: [FilingRestrictionBlockComponent, SupportSettingsBlockComponent],
  declarations: [FilingRestrictionBlockComponent, SupportSettingsBlockComponent],
  providers: [],
})
export class ManagementSharedModule {}
